




































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EwssAnakScoringMatrix extends Vue {
  @Prop({ default: null }) readonly currentVitals: any;

  get hasData(): boolean {
    return !!this.currentVitals;
  }

  get kardioSkor(): number {
    return this.currentVitals?.ews_anak_kardiovaskuler_skor ?? 0;
  }

  get respSkor(): number {
    return this.currentVitals?.ews_anak_respirasi_skor ?? 0;
  }

  get kuSkor(): number {
    return this.currentVitals?.ews_anak_kesadaran_skor ?? 0;
  }

  get totalSkor(): number {
    return this.currentVitals?.ews_anak_skor ?? 0;
  }

  // Sub-scores for detail display
  get sianosisScore(): number {
    const s = this.currentVitals?.sianosis;
    return s ? s - 1 : 0;
  }

  get kapilerScore(): number {
    const k = this.currentVitals?.kapiler;
    if (!k) return 0;
    if (k < 2) return 0;
    if (k == 2) return 1;
    if (k <= 5) return 2;
    return 3;
  }

  get nadiScore(): number {
    const nadi = this.currentVitals?.frekuensi_nadi;
    const normalRange = this.currentVitals?.normal_anak_frek_nadi;
    if (!nadi || !normalRange || !normalRange.max) return 0;
    if (nadi < normalRange.min || nadi > normalRange.max + 30) return 3;
    if (nadi > normalRange.max + 20) return 3;
    if (nadi > normalRange.max) return 2;
    return 0;
  }

  get rrScore(): number {
    const rr = this.currentVitals?.frekuensi_nafas;
    const normalRange = this.currentVitals?.normal_anak_frek_nafas;
    if (!rr || !normalRange || !normalRange.max) return 0;
    if (rr > normalRange.max + 20 || rr < normalRange.min - 5) return 3;
    if (
      (rr > normalRange.max + 10 && rr <= normalRange.max + 20) ||
      (rr < normalRange.min && rr >= normalRange.min - 5)
    )
      return 2;
    if (rr > normalRange.max && rr <= normalRange.max + 10) return 1;
    return 0;
  }

  get retraksiScore(): number {
    return this.currentVitals?.retraksi === "y" ? 1 : 0;
  }

  get o2Score(): number {
    const o2 = this.currentVitals?.suplemeno2;
    if (!o2 || o2 <= 0) return 0;
    if (o2 >= 1 && o2 <= 3) return 1;
    if (o2 > 3 && o2 <= 6) return 2;
    return 3;
  }

  get totalColor(): string {
    if (this.currentVitals?.henti_jantung === "y") return "blue";
    const s = this.totalSkor;
    if (s >= 5) return "red";
    if (s >= 3) return "orange";
    return "green";
  }

  get totalKategori(): string {
    if (this.currentVitals?.henti_jantung === "y")
      return "HENTI JANTUNG — RJP + Aktivasi 666";
    const s = this.totalSkor;
    if (s >= 5) return "KRITIS — Aktivasi Tim Sekunder (777/888)";
    if (s >= 3) return "RISIKO SEDANG — Monitoring tiap 1 jam, konsultasi DPJP";
    return "RISIKO RINGAN — Evaluasi tiap 4 jam";
  }

  skorColor(skor: number): string {
    if (skor >= 3) return "red";
    if (skor >= 2) return "orange";
    if (skor >= 1) return "amber darken-2";
    return "green";
  }

  get kardioKriteria() {
    return [
      { skor: 0, kriteria: "Tidak sianosis, ATAU Pengisian kapiler 1-2 detik" },
      { skor: 1, kriteria: "Tampak pucat, ATAU Pengisian kapiler 2 detik" },
      {
        skor: 2,
        kriteria:
          "Tampak sianotik, ATAU Pengisian kapiler > 2 detik, ATAU Takikardi > 20x di atas parameter nadi sesuai usia"
      },
      {
        skor: 3,
        kriteria:
          "Sianotik dan motlet, ATAU Pengisian kapiler > 5 detik, ATAU Takikardi > 30x di atas parameter nadi sesuai usia, ATAU Bradikardia"
      }
    ];
  }

  get respKriteria() {
    return [
      {
        skor: 0,
        kriteria: "Frekuensi napas normal, Tidak ada retraksi, Udara ruangan"
      },
      {
        skor: 1,
        kriteria:
          "Takipnea > 10x di atas normal, ATAU Otot bantu napas, ATAU FiO2 > 30% (>= 3 L/mnt)"
      },
      {
        skor: 2,
        kriteria:
          "Takipnea > 20x di atas normal, ATAU Retraksi, ATAU FiO2 > 40% (>= 6 L/mnt)"
      },
      {
        skor: 3,
        kriteria:
          "Takipnea >= 5x di atas normal + retraksi, ATAU Merintih, ATAU FiO2 > 50% (>= 8 L/mnt)"
      }
    ];
  }

  get kuKriteria() {
    return [
      { skor: 0, kriteria: "Interaksi biasa" },
      { skor: 1, kriteria: "Somnolen" },
      { skor: 2, kriteria: "Iritabel" },
      {
        skor: 3,
        kriteria: "Letargi, gelisah, penurunan respons terhadap nyeri"
      }
    ];
  }
}
